import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";
import { Button, Label, TextArea, Input } from "abs-ui-components";
import "./FeuB6PowerDemandAtBerth.scss";
import { FeuB6FormFields } from "../../FeuConstants.js";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes.js";
import { callApi } from "../../../../../services/MonitoringPlanService.js";
import { emitToasterMsg } from "../../../../../services/toasterUtility.js";
import AutoSave from "../../../../../common/AutoSave/AutoSave.js";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants.js";

const FeuB6PowerDemandAtBerth = forwardRef(({ b6PowerDemandAtBerth, refetchMonitoringData,vesselMstId }, ref) => {

	const { control, getValues, reset, formState } = useFormContext();
	const { isDirty } = formState;
	const lastManualSave = useRef(null);
	const manualSaveTriggered = useRef(false);


	useEffect(() => {
		if (b6PowerDemandAtBerth) {
			reset(prev => ({ ...prev, b6: b6PowerDemandAtBerth }));
		}
	}, [b6PowerDemandAtBerth, reset]);

	AutoSave(ref, [], async () => {
		if (!isDirty) return;
		await handleSave(true);
	});

	const handleSave = async (isAuto = false) => {
		const formValues = getValues("b6");
		const payload = {};
		FeuB6FormFields.forEach(({ name, type }) => {
			let value = formValues[name];
			if (type === "number" && value !== "" && value != null) {
				value = Number(value);
			}
			if (value !== undefined && value !== null && value !== "") {
				payload[name] = value;
			}
		});

		try {
			const b6EmissionFactors = await callApi({
				method: "POST",
				url: API_ROUTES.B6(vesselMstId),
				data: payload,
			});

			if (b6EmissionFactors?.isSuccess) {
				emitToasterMsg("success", "Table B.6", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
				reset(prev => ({ ...prev, b6: formValues }));
				if (!isAuto) {
					lastManualSave.current = Date.now();
				}
				if (typeof refetchMonitoringData === "function") {
					await refetchMonitoringData();
				}
			} else {
				emitToasterMsg("error", "Table B.6", b6EmissionFactors?.errorMessage);
			}
		} catch (error) {
			emitToasterMsg("error", "Table B.6", error?.errorMessage || "Unknown error");
		}
	};

	return (
		<div className="b6-section-form mt-4">
			{FeuB6FormFields.map(({ label, name, maxLength, type, step, inputMode }, index) => (
				<MDBRow className="align-items-center mb-3" key={index}>
					<MDBCol md="4">
						<Label name={label} bold />
					</MDBCol>
					<MDBCol md="4">
						<Controller
							name={`b6.${name}`}
							control={control}
							defaultValue="" /* Provide a safe default */
							render={({ field }) =>
								type === "number" ? (
									<Input
										id={`b6_${name}`}
										{...field}
										type="number"
										inputMode={inputMode}
										step={step}
										className="form-control"
										placeholder=""
										onChange={field.onChange}
									/>

								) : (
									<TextArea
										id={`b6_${name}`}
										className="textarea-resize"
										value={field.value || ""}
										onChange={field.onChange}
										placeholder=""
										maxLength={maxLength}
										rows={1}
									/>
								)
							}
						/>
					</MDBCol>
				</MDBRow>
			))}

			<div className="text-center">
				<Button id="b6_save_btn"
					disabled={!isDirty}
					onClick={async () => {
						manualSaveTriggered.current = true;
						await handleSave(false);
					}}
				>
					Save
				</Button>
			</div>
		</div>
	);
});

export default FeuB6PowerDemandAtBerth;
